import vidbg from 'vidbg.js';

interface VidbgOptions {
	mp4: string;
	webm: string;
	poster: string;
	overlay: boolean;
	overlayColor: string;
	overlayAlpha: number;
}

/**
 * Background Video class.
 */
class BackgroundVideo {
	constructor() {
		this.init();
	}

	init() {
		const bgVideoEls = document.querySelectorAll(
			'[data-background-video]'
		) as NodeListOf<HTMLElement>;
		bgVideoEls.forEach((el, index) => {
			const selector = 'vidbg-' + index;
			const videoSrc = el.dataset.backgroundVideo;
			const videoPoster = el.dataset.poster;

			el.setAttribute('id', selector);

			const args = {
				mp4: videoSrc,
				poster: videoPoster,
				overlay: false,
			} as VidbgOptions;
			new vidbg('#' + selector, args);
		});
	}
}

// Run BackgroundVideo.
new BackgroundVideo();
